import { render, staticRenderFns } from "./detalhesBoleto.vue?vue&type=template&id=4990df50&scoped=true&"
import script from "./detalhesBoleto.vue?vue&type=script&lang=js&"
export * from "./detalhesBoleto.vue?vue&type=script&lang=js&"
import style0 from "./detalhesBoleto.vue?vue&type=style&index=0&id=4990df50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4990df50",
  null
  
)

export default component.exports